import { render, staticRenderFns } from "./EditOrderForm.vue?vue&type=template&id=8816758a&scoped=true"
import script from "./EditOrderForm.vue?vue&type=script&lang=js"
export * from "./EditOrderForm.vue?vue&type=script&lang=js"
import style0 from "./EditOrderForm.vue?vue&type=style&index=0&id=8816758a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8816758a",
  null
  
)

export default component.exports